// extracted by mini-css-extract-plugin
export default {"button":"check-button_button__QGmlu common_button__gAtsh","active":"check-button_active__ESVg+"};